import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import { Card, Row, Col, Button } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../../BaseComponent'
import Filters, { FilterItem, Types } from '../../../Filters'
import ShelterTaxList from '../../../ShelterTaxList'
import { ShelterTaxForm } from '../../../Forms'
import { ShelterTaxConsumer } from '../../../../context/ShelterTaxContext'
import { SearchRequest } from '../../../../services/api/interfaces/ApiRequest'

type TaxProps = BaseFormComponentProps & RouteComponentProps & {
  uuid: string,

  shelter: any | null,
  loadShelter: (args: SearchRequest) => void,
}

class Tax extends FormComponent<TaxProps> {

  state = {
    saving: false
  }

  private taxDispatchOptions = {
    search: {
      shelter: {
        has: {
          uuid: this.props.uuid
        }
      },
      'tax_branch': {
        with: {
          deleted: false,
          _exists: true,
          branch: {
            with: true
          }
        }
      }
    },
    options: {
      _force_ids: true
    }
  } as const

  componentDidMount() {
    const { uuid, shelter, loadShelter } = this.props

    if (!shelter) {
      loadShelter({
        search: {
          uuid: uuid,
          contract_options: {
            with: {
              deleted: false
            }
          },
          organization_question_shelters: {
            with: {
              deleted: false,
              kiosk_reason_id: null,
              question_shelter_species: {
                with: true
              }
            }
          },
          organization_branches: {
            with: true
          },
          shelter_contract: {
            with: true
          }
        },
        options: {
          _force_ids: true
        }
      })
    }
  }

  renderAdd = () => {
    const { uuid, permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to={`/organization/shelter/${uuid}/tax/add`}>
        <Button type="primary" shape="round">
          Add
        </Button>
      </Link>
    )
  }

  render() {
    const { uuid, shelter, permissions, history, match } = this.props
    const { params: { entityUuid } }: any = match

    const branchToFilter = shelter?.organization_branches?.map(branch => {
      return {
        value: branch.id,
        text: branch.name
      }
    }) || []

    if (entityUuid) {
      return (
        <ShelterTaxConsumer>
          {({ fetching, tax, error, requestShelterTaxFind, requestShelterTaxCreate, requestShelterTaxUpdate }) => (
            <ShelterTaxForm
              uuid={entityUuid !== 'add' ? entityUuid : null}
              data={tax}
              error={error}

              shelterUuid={uuid}
              shelter={shelter}

              loading={fetching || false}
              history={history}

              loadTax={requestShelterTaxFind}

              dispatchCreate={requestShelterTaxCreate}
              dispatchUpdate={requestShelterTaxUpdate}
            />
          )}
        </ShelterTaxConsumer>
      )
    }

    return (
      <ShelterTaxConsumer>
        {({ fetching, taxes, pagination, requestShelterTaxList, requestShelterTaxDelete }) => (
          <>
            <Card title="Filters" style={{marginBottom: 25}}>
              <Filters size="medium" defaultSubmitOptions={this.taxDispatchOptions} submitDispatch={requestShelterTaxList} loading={fetching}>
                {({ values, handleFilterChange }: any) => (
                  <Row gutter={9}>
                    <Col xs={24} md={10}>
                      <FilterItem
                        name="uuid"
                        type={Types.INPUT}
                        placeholder="UUID"
                        value={values['uuid']}
                        size="medium"
                        options={{
                          input: {
                            allowClear: true
                          }
                        }}
                        onChange={handleFilterChange}
                      />
                    </Col>
                    <Col xs={24} md={6}>
                      <FilterItem
                        name="name"
                        type={Types.INPUT}
                        placeholder="Name"
                        value={values['name']}
                        size="medium"
                        options={{
                          input: {
                            allowClear: true
                          }
                        }}
                        onChange={handleFilterChange}
                      />
                    </Col>
                    <Col xs={24} md={8}>
                      <FilterItem
                        name="tax_branch.branch_id"
                        loading={!shelter}
                        type={Types.SELECT}
                        placeholder="Location"
                        data={branchToFilter as any || []}
                        value={values['tax_branch.branch_id']}
                        size="medium"
                        options={{
                          select: {
                            allowClear: true,
                            showSearch: true
                          }
                        }}
                        onChange={handleFilterChange}
                      />
                    </Col>
                  </Row>
                )}
              </Filters>
            </Card>

            <Card title="List of Taxes" extra={this.renderAdd()}>
              <ShelterTaxList shelterUuid={uuid} loading={fetching} taxes={taxes} pagination={pagination} permissions={permissions} history={history} deleteTax={requestShelterTaxDelete} loadTaxes={requestShelterTaxList} />
            </Card>
          </>
        )}
      </ShelterTaxConsumer>
    )
  }
}

export default withRouter(Tax)
